import React from 'react';

const QualityMeter = ({ score, compact }) => {
  const getQualityLabel = (score) => {
    if (score >= 90) return 'Excellent';
    if (score >= 70) return 'Great';
    if (score >= 50) return 'Good';
    if (score >= 30) return 'Getting there';
    return 'Just starting';
  };

  const getQualityColor = (score) => {
    if (score >= 90) return '#10b981';
    if (score >= 70) return '#3b82f6';
    if (score >= 50) return '#f59e0b';
    if (score >= 30) return '#f97316';
    return '#ef4444';
  };

  const color = getQualityColor(score);
  const label = getQualityLabel(score);

  if (compact) {
    return (
      <div className="quality-meter quality-meter--compact">
        <div className="quality-meter-bar quality-meter-bar--compact">
          <div
            className="quality-meter-fill quality-meter-fill--gold"
            style={{ height: `${score}%` }}
          />
        </div>
        <span className="quality-meter-label">{label}</span>
      </div>
    );
  }

  return (
    <div className="quality-meter">
      <div className="quality-meter-header">
        <span className="quality-label">Itinerary Quality</span>
        <span className="quality-score">{score}%</span>
      </div>
      <div className="quality-meter-bar">
        <div
          className="quality-meter-fill"
          style={{
            width: `${score}%`,
            backgroundColor: color,
          }}
        />
      </div>
      <div className="quality-meter-label">{label}</div>
    </div>
  );
};

export default QualityMeter;
